<template>
  <el-card>
    <el-form ref="ruleForm" label-position="top">
      <ShippingIntegrationAddFormHeader ref="header" />
      <ShippingAddFormFooter :updated="updated" @submit="submitForm" redirect="shipping.integration" />
    </el-form>
  </el-card>
</template>
<script>

import ShippingAddFormFooter from "../components/config/ShippingAddFormFooter.vue";
import { ShippingIntegrationService } from "@/services/shipping/shipping.integration.services";
import ShippingIntegrationAddFormHeader from "./components/ShippingIntegrationAddFormHeader.vue";

export default {
  name: "ShippingIntegrationAddForm",
  components: {
    ShippingAddFormFooter,
    ShippingIntegrationAddFormHeader
},
  computed: {
    updated() {
      return this.id !== '';
    }
  },
  data() {
    return {
      id: "",
      tableRestricted: [],
      activeTab: "tabconfig",
    };
  },
  methods: {
    submitForm() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      const formData = vm.$refs.header.data;
      console.log('formData', formData);
      ShippingIntegrationService.create(formData)
        .then((response) => {
          this.$message({
            type: "success",
            message: 'Integração de transportadora adicionada com sucesso',
          });
          this.$router.push({ name: 'shipping.integration' });
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
  },
  mounted() {
    const vm = this;
  },
};
</script>
